import React, { Component, Fragment } from "react";
import checkPermissions from "../../utils/permissionManager";
import { siteViewNew } from '../../api/api.config';
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { DatePicker, Table, List, Skeleton, Select, Tag, Row, Col, Input, Button, message, Menu, Dropdown, Modal, Card, Collapse, Form, Divider, Badge, Tabs } from "antd";
import { getDonationCategories, getData } from "../../actions/index";
import {
  getAllDepotList,
  getSitesLiteForSiteManage,
  getAllSiteCategories,
  removeSite,
  getStatistics,
  getFilterDetails,
  getAllRegionRelatedData,
  getAllSitesListByID,
  getMapQueryTemplateByUser
} from "../../api/index";
import '../master-data/style.css';
import axios from 'axios';
import { checkServiceType } from "../../actions/service-type";
import {
  GlobalOutlined, HomeOutlined, WifiOutlined, ReloadOutlined, SearchOutlined, EnvironmentOutlined, PlusOutlined,
  FilterOutlined, CloseCircleOutlined, EditOutlined, DownOutlined, ExclamationCircleOutlined, DeleteFilled, DeleteOutlined, MoreOutlined,
  MinusCircleOutlined, EditFilled, EyeFilled, PlayCircleOutlined,
  EyeOutlined
} from '@ant-design/icons';

const { Option } = Select;
const { Panel } = Collapse;

class SiteAll extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNo: 1,
      editVisibilty: false,
      site_list: [],
      site_name: "",
      site_id: "",
      depotList: [],
      depot_list_new: [],
      isOpen: false,
      loading: true,
      depotId: "",
      setLogin: false,
      AssetManagementPermission: false,
      filterButton: true,
      setSearchValue: "",
      filteredTable: null,
      setValues: null,
      depot_list: [],
      sitwCategory: [],
      filterRegion: null,
      filterDepot: null,
      filterCategory: null,
      fullAllSite: [],
      staticalData: [],
      allSiteList: [],
      siteOwnerList: [],
      towerCategoryList: [],
      towerTypeList: [],
      siteTypeList: [],
      allRegions: [],
      allDepots: [],
      openFilter: false,
      loadFullSiteList: [],
      mapQuery: {
        siteIds: [],
        regionIds: [],
        depotIds: [],
        status: null,
        siteOwnerIds: [],
        siteTypeIds: [],
        towerCategoryIds: [],
        towerTypeIds: []
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        lastSeenId: 0,
        hasNextPage: true
      },
      paginationParams: {},
      isActiveFilter: false,
      inlineSearchID: 0,
      selectedRegionID: [],
      selectedDepotID: [],
      newSiteList: [],
      savedTemplates: [],
      searchSavedTemplates: []
    };
  }

  componentDidMount() {
    this.props.getData();
    this.setState({
      depot_list: this.props.depots,
    });
    checkServiceType(38).then((data) =>
      this.setState(
        {
          AssetManagementPermission: data,
        },
        () => {
          console.log(this.state.AssetManagementPermission);
        }
      )
    );
    if (JSON.parse(localStorage.getItem("serviceTypeSet")) == null) {
      this.setState({
        setLogin: true,
      });
    }
    this.fetchStatisticsFunction();
    this.fetchTowerCategoryList();
    this.fetchTowerTypeList();
    this.fetchSiteTypeList();
    this.fetchSiteOwnerList();
    this.fetchSiteList();
    this.fetchRegionList();
    this.fetchDepotList();
    this.fetchAllSiteListSet();
    this.fetchNewSiteList();
    this.loadAllSavedTemplates();
  }


  fetchNewSiteList = async () => {
    try {
      const response = await axios.get(siteViewNew + 'api/v1/site-view/list', {
        headers: {
          "userId": localStorage.getItem("userId")
        }
      });
      this.setState({
        newSiteList: response?.data?.results
      })
    } catch (error) {
      console.error("Error fetching site list:", error);
    }
  }

  loadAllSavedTemplates = async () => {
    try {
      const response = await getMapQueryTemplateByUser(localStorage.getItem("userId"));
      this.setState({
        savedTemplates: response?.data,
        searchSavedTemplates: response?.data
      });
    } catch (error) {
      message.error("Error fetching saved templates", 5);
    }
  }

  filterTemplatesByName = (value) => {
    const lowercasedValue = value.toLowerCase();
    const filteredItems = this.state.savedTemplates.filter((item) => item.templateName.toLowerCase().includes(lowercasedValue));
    this.setState({
      searchSavedTemplates: filteredItems
    });
  };


  fetchAllSiteListSet = async () => {
    var responseAPI = await getAllSitesListByID();
    if (responseAPI.success) {
      const customSite = [{
        "id": 0,
        "siteName": "All",
        "siteId": 'Sites',
        "accessPermission": null
      }]
      customSite.push(...responseAPI.data);
      this.setState({
        loadFullSiteList: customSite,
      });
    }
  }

  fetchSiteOwnerList = async () => {
    const response = await getFilterDetails('siteOwner');
    console.log(response);
    if (response.success) {
      this.setState({
        siteOwnerList: response.data,
      });
    }
  };

  fetchTowerCategoryList = async () => {
    const response = await getFilterDetails('towerCategory');
    console.log(response);
    if (response.success) {
      this.setState({
        towerCategoryList: response.data,
      });
    }
  };

  fetchTowerTypeList = async () => {
    const response = await getFilterDetails('towerType');
    console.log(response);
    if (response.success) {
      this.setState({
        towerTypeList: response.data,
      });
    }
  };

  fetchSiteTypeList = async () => {
    const response = await getFilterDetails('siteType');
    console.log(response);
    if (response.success) {
      this.setState({
        siteTypeList: response.data,
      });
    }
  };

  fetchRegionList = async () => {
    const response = await getAllRegionRelatedData('permission-regions');
    if (response.success) {
      this.setState({
        allRegions: response?.data?.results ? response.data.results : [],
      });
    }
  }

  fetchDepotList = async () => {
    const response = await getAllRegionRelatedData('permission-depots');
    if (response.success) {
      this.setState({
        allDepots: response?.data?.results ? response?.data?.results : [],
      });
    }
  }

  fetchStatisticsFunction = async () => {
    try {
      const response = await axios.get(siteViewNew + 'api/v1/statistics');
      console.log(response?.data?.results);
      this.setState({
        staticalData: response?.data?.results,
      })
    } catch (err) {

    } finally {
      console.log('Problem With the request');
    }
  }

  fetchSiteList = async () => {
    this.setState({
      loading: true,
      mapQuery: {
        siteIds: [],
        regionIds: [],
        depotIds: [],
        status: null,
        siteOwnerIds: [],
        siteTypeIds: [],
        towerCategoryIds: [],
        towerTypeIds: []
      }
    });
    let fetchData = [];
    const pageSize = 100;
    let hasNextPage = this.state.pagination.hasNextPage;
    let lastSeenId = this.state.pagination.lastSeenId;
    let apiCallCount = 0;
    while (hasNextPage && apiCallCount < 1) {
      try {
        const response = await axios.post(siteViewNew + 'api/v1/site-view',
          {
            siteIds: [],
            regionIds: [],
            depotIds: [],
            status: null,
            siteOwnerIds: [],
            siteTypeIds: [],
            towerCategoryIds: [],
            towerTypeIds: []
          },
          {
            params: {
              lastSeenId,
              pageSize
            },
            headers: {
              "userId": localStorage.getItem("userId")
            }
          },
        );
        if (response.data?.results?.data) {
          fetchData = [...fetchData, ...response?.data?.results?.data];
        }
        lastSeenId = response?.data?.results?.lastSeenId;
        hasNextPage = response?.data?.results?.hasNextPage;
        this.setState({
          pagination: {
            ...this.state.pagination,
            lastSeenId,
            hasNextPage
          }
        });
        apiCallCount++;
        if (!hasNextPage) break;
      } catch (err) {
        console.error('Error fetching data:', err);
        break;
      }
    }
    this.setState({
      loading: false,
      allSiteList: [...this.state.allSiteList, ...fetchData]
    });
  };

  handleTableChange = (pagination) => {
    this.setState({
      pagination: {
        ...this.state.pagination,
        current: pagination.current,
        totalPages: Math.ceil(pagination.total / pagination.pageSize)
      },
    });
    if ((pagination.current > this.state.pagination.totalPages - 5) && this.state.pagination.hasNextPage) {
      if (!this.state.isActiveFilter) {
        this.fetchSiteList();
      } else {
        let { hasNextPage, lastSeenId } = this.state.pagination;
        this.filterBtnClick(this.state.paginationParams, lastSeenId, hasNextPage);
      }
    }
  };


  getAllSiteCategories = async () => {
    var res = await getAllSiteCategories();
    if (res.success) {
      this.setState({
        sitwCategory: res.data,
      });
    }
  };

  showErrorMessage = (message) => {
    Modal.error({
      title: 'Error',
      content: <span className='textStyles-small'>{message}</span>,
      onOk() { },
    });
  };

  removeSitesFromList = async (siteID) => {
    const fromData = new FormData();
    fromData.append("siteId", siteID);
    const res = await removeSite(fromData);
    console.log(res);
    if (res.success) {
      message.success("Site deactivated successfully");
      this.setState({
        allSiteList: []
      });
      this.fetchSearchBar(this.state.inlineSearchID);
    } else {
      this.showErrorMessage(res.data.data);
    }
  }


  fetchSiteListFilter = async (siteIdsP = [], regionIdsP = [], depotIdsP = [], statusP = null, siteOwnerIdsP = [], siteTypeIdsP = [], towerCategoryIdsP = [], towerTypeIdP = [], lastSeenId, hasNextPage) => {
    this.setState({
      loading: true,
      mapQuery: {
        siteIds: siteIdsP,
        regionIds: regionIdsP,
        depotIds: depotIdsP,
        status: statusP,
        siteOwnerIds: siteOwnerIdsP,
        siteTypeIds: siteTypeIdsP,
        towerCategoryIds: towerCategoryIdsP,
        towerTypeIds: towerTypeIdP
      }
    });
    const pageSize = 100;
    let apiCallCount = 0;
    let fetchData = [];

    // let { hasNextPage, lastSeenId } = this.state.pagination;
    const requestBody = {
      siteIds: siteIdsP,
      regionIds: regionIdsP,
      depotIds: depotIdsP,
      status: statusP,
      siteOwnerIds: siteOwnerIdsP,
      siteTypeIds: siteTypeIdsP,
      towerCategoryIds: towerCategoryIdsP,
      towerTypeIds: towerTypeIdP
    };

    try {
      while (hasNextPage && apiCallCount < 1) {
        const response = await axios.post(siteViewNew + 'api/v1/site-view',
          requestBody,
          {
            params: {
              lastSeenId,
              pageSize
            },
            headers: {
              "userId": localStorage.getItem("userId")
            }
          }
        );

        if (response.data?.results?.data) {
          fetchData = response.data.results.data;
        }
        lastSeenId = response?.data?.results?.lastSeenId;
        hasNextPage = response?.data?.results?.hasNextPage;
        apiCallCount++;

        if (!hasNextPage) break;
      }
    } catch (err) {
      console.error('Error fetching data:', err);
    }

    let exisitingData = this.state.allSiteList;
    this.setState({
      loading: false,
      allSiteList: [...exisitingData, ...fetchData],
      openFilter: false,
      pagination: {
        ...this.state.pagination,
        lastSeenId,
        hasNextPage
      }
    });
  };

  filterBtnClick = (values, lastSeenId, hasNextPage) => {
    this.setState({
      inlineSearchID: 0,
    });
    this.fetchSiteListFilter(
      values.siteIds ? values.siteIds : null,
      values.region ? values.region : null,
      values.depot ? values.depot : null,
      values.status ? values.status : null,
      values.siteOwner ? values.siteOwner : null,
      values.siteType ? values.siteType : null,
      values.towerCategory ? values.towerCategory : null,
      values.towerType ? values.towerType : null,
      lastSeenId ? lastSeenId : 0,
      hasNextPage ? hasNextPage : true
    )
  }

  searchBar = (values) => {
    console.log(values);
    this.setState({
      isActiveFilter: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        lastSeenId: null,
        hasNextPage: true
      }
    });
    const getValue = values.value;
    if (getValue == 0 || getValue == '0' || getValue == 'All' || getValue == 'all' || getValue == undefined || getValue === undefined || getValue === 0) {
      this.fetchSiteList();
    } else {
      this.fetchSearchBar(values.value);
    }
  }

  fetchSearchBar = async (siteID) => {
    this.setState({
      loading: true,
      allSiteList: [],
      mapQuery: {
        siteIds: [siteID],
        regionIds: [],
        depotIds: [],
        status: null,
        siteOwnerIds: [],
        siteTypeIds: [],
        towerCategoryIds: [],
        towerTypeIds: [],
      },
    });
    const pageSize = 1;
    let hasNextPage = false;
    let lastSeenId = null;
    try {
      const response = await axios.post(siteViewNew + 'api/v1/site-view',
        {
          siteIds: [siteID],
          regionIds: [],
          depotIds: [],
          status: null,
          siteOwnerIds: [],
          siteTypeIds: [],
          towerCategoryIds: [],
          towerTypeIds: [],
        },
        {
          params: {
            lastSeenId,
            pageSize,
          },
          headers: {
            "userId": localStorage.getItem("userId")
          }
        }
      );

      if (response.data?.results?.data) {
        this.setState({
          allSiteList: response.data.results.data,
        });
      }

      lastSeenId = response?.data?.results?.lastSeenId || null;
      hasNextPage = response?.data?.results?.hasNextPage || false;

      this.setState((prevState) => ({
        pagination: {
          ...prevState.pagination,
          lastSeenId,
          hasNextPage,
        },
      }));
    } catch (err) {
      console.error('Error fetching data:', err.message);
      return;
    } finally {
      this.setState({ loading: false });
    }
  };



  render() {
    const columns123 = [
      {
        title: <span className='textStyles-small' style={{ fontSize: 12 }}>Site ID</span>,
        render: (text, record, index) => (
          <span className='textStyles-small' >
            <Link className='textStyles-small' to={"/site/new/" + text.id} style={{ color: 'black' }}>{text?.siteId}</Link>
          </span>
        ),
      },
      {
        title: <span className='textStyles-small' style={{ fontSize: 12 }}>Site Name</span>,
        key: "siteName",
        render: (item) => (
          <span className='textStyles-small' >
            <Link className='textStyles-small'
              style={{ fontSize: 12, color: 'black' }}
              to={"/site/new/" + item.id}>{item?.siteName}</Link>
          </span>
        ),
      },
      {
        title: <span className='textStyles-small' style={{ fontSize: 12 }}>Region</span>,
        key: "accessPermissionCode",
        render: (item) => <span>{item.region}</span>,
      },
      {
        title: <span className='textStyles-small' style={{ fontSize: 12 }}>Depot</span>,
        key: "accessPermissionCode",
        render: (item) => <span className='textStyles-small' >{item?.depot}</span>,
      },
      {
        title: <span className="textStyles-small">Status</span>,
        dataIndex: 'status',
        key: 'status',
        render: (text) => {
          let color = '#1FAD4B36';
          let fontColor = '#1FAD4B';
          let displayText = 'Active';
          if (text?.toLowerCase() === 'inactive' || text?.toLowerCase() === 'deactivated' || text?.toLowerCase() === 'removed') {
            color = '#C4C4C452';
            fontColor = '#979797';
            displayText = 'Removed';
          } else if (text?.toLowerCase() === 'live' || text?.toLowerCase() === 'active') {
            color = '#1FAD4B36';
            fontColor = '#1FAD4B';
            displayText = 'Live';
          }
          return (
            <Tag color={color} style={{ padding: 5, borderRadius: 5 }} key={text} className="textStyles-small">
              <span style={{ color: fontColor, fontWeight: 550, fontSize: '12px' }} className="textStyles-small">
                {displayText}
              </span>
            </Tag>
          );
        }
      },
      {
        title: <span className='textStyles-small' style={{ fontSize: 12 }}>Site Category</span>,
        align: "center",
        key: "siteCategory",
        render: (item) => (
          <span class="badge badge-outline-primary badge-pill textStyles-small">
            {item?.siteCategory}
          </span>
        ),
      },
      {
        title: <span className='textStyles-small' style={{ fontSize: 12 }}>Site Owner</span>,
        key: "siteOwnerName ",
        render: (item) => <span className='textStyles-small'>{item?.siteOwnerName}</span>,
      },
      {
        title: <span className='textStyles-small' style={{ fontSize: 12 }}>Tower Category</span>,
        key: "towerCategoryName",
        align: "right",
        width: "9%",
        render: (item) => (
          <span className='textStyles-small'>
            {item?.towerCategoryName}
          </span>
        ),
      },
      this.state.AssetManagementPermission ? {
        title: <span className='textStyles-small' style={{ fontSize: 12 }}>Action</span>,
        key: "ContactNo",
        align: "center",
        hidden: true,
        render: (item) => {
          const menu = (
            <Menu>
              <Menu.Item key="list-loadmore-edit-1" icon={<EyeOutlined style={{ color: 'blue' }} />}>
                <Link className='textStyles-small' to={"/site/new/" + item.id}>
                  <span className='textStyles-small'>View Site</span>
                </Link>
              </Menu.Item>
              {
                (checkPermissions('SITE_VIEW_GENERAL_USER') || checkPermissions('SITE_VIEW_ADMIN_USER')) && (
                  <Menu.Item key="list-loadmore-edit-1" icon={<EditOutlined style={{ color: 'green' }} />}>
                    <Link to={"/site/update/" + item.id + '/existing'}>
                      <span className='textStyles-small'>Edit Site</span>
                    </Link>
                  </Menu.Item>
                )
              }
              {
                checkPermissions('SITE_VIEW_ADMIN_USER') && (
                  <Menu.Item key="list-loadmore-edit-3" icon={<MinusCircleOutlined style={{ color: 'red' }} />}>
                    <span className='textStyles-small' onClick={() => showUpdateConfirmationModal(item.id)}>Deactivate Site</span>
                  </Menu.Item>
                )
              }
            </Menu>
          );

          return (
            <Dropdown overlay={menu}>
              <Button
                type="primary"
                style={{ backgroundColor: '#F28603', borderColor: '#F28603' }}
                size="small"
                icon={<MoreOutlined />}
                shape="circle" />
            </Dropdown>
          );
        },
      }

        : {},
    ];

    const showUpdateConfirmationModal = (siteID) => {
      Modal.confirm({
        title: 'Confirm',
        icon: <ExclamationCircleOutlined />,
        content: <span className='textStyles-small'>Do you want to deactivate this site?</span>,
        okText: 'Yes',
        cancelText: 'No',
        onOk: async () => this.removeSitesFromList(siteID),
      });
    };

    const tabItems = [
      {
        key: '1',
        label: <span className='textStyles-small' style={{ fontSize: 12 }}>Basic Filter</span>,
        children: <Fragment>
          <Form
            name="basic"
            initialValues={{ remember: true }}
            onFinish={(values) => {
              this.filterBtnClick(values);
              this.setState({
                isActiveFilter: true,
                allSiteList: [],
                pagination: {
                  current: 1,
                  pageSize: 10,
                  total: 0,
                  totalPages: 0,
                  lastSeenId: 0,
                  hasNextPage: true
                },
                paginationParams: {
                  siteIds: values?.siteIds ? values.siteIds : null,
                  region: values?.region ? values.region : null,
                  depot: values?.depot ? values.depot : null,
                  status: values?.status ? values.status : null,
                  siteOwner: values?.siteOwner ? values.siteOwner : null,
                  siteType: values?.siteType ? values.siteType : null,
                  towerCategory: values?.towerCategory ? values.towerCategory : null,
                  towerType: values?.towerType ? values.towerType : null,
                }
              });
            }}
          >
            <Collapse ghost={true} expandIconPosition="end" style={{ backgroundColor: 'white' }}>
              <Panel header={<span className="textStyles-small" style={{ fontSize: 12 }}>Region</span>} key="2">
                <Form.Item name="region">
                  <Select
                    placeholder="Select Region"
                    bordered={false}
                    style={{ width: "100%", height: 'auto' }}
                    className='borderedSelect'
                    mode='multiple'
                    showSearch
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(value) => {
                      this.setState({
                        selectedRegionID: value
                      })
                    }
                    }
                  >
                    {this.state.allRegions.map((region) => (
                      <Option className="textStyles-small" key={region?.id} value={region?.id}>
                        {region.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Panel>
              <Divider />
              <Panel header={<span className="textStyles-small" style={{ fontSize: 12 }}>Depot</span>} key="3">
                <Form.Item name="depot">
                  <Select
                    placeholder="Select Depot"
                    bordered={false}
                    style={{ width: "100%", height: 'auto' }}
                    showSearch
                    mode='multiple'
                    className='borderedSelect'
                    onChange={(value) => {
                      this.setState({
                        selectedDepotID: value
                      })
                    }}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {
                      this.state.selectedRegionID.length === 0 ? (
                        this.state.allDepots.map((depot) => (
                          <Option className="textStyles-small" key={depot.id} value={depot.id}>
                            {depot.name}
                          </Option>
                        ))
                      ) : (
                        this.state.allDepots
                          .filter((depot) => this.state.selectedRegionID?.includes(depot?.parentRegionId))
                          .map((depot) => (
                            <Option className="textStyles-small" key={depot.id} value={depot.id}>
                              {depot.name}
                            </Option>
                          ))
                      )
                    }
                  </Select>
                </Form.Item>
              </Panel>
              <Divider />
              <Panel header={<span className="textStyles-small" style={{ fontSize: 12 }}>Site</span>} key="10">
                <Form.Item name="siteIds">
                  <Select placeholder="Select Status" bordered={false}
                    style={{ width: "100%", height: 'auto' }}
                    showSearch
                    mode='multiple'
                    filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    className='borderedSelect'>

                    {
                      this.state.selectedRegionID.length === 0 && this.state.selectedDepotID.length === 0 ? (
                        this.state.newSiteList.map((site) => (
                          <Option className="textStyles-small" key={site.id} value={site.id}>
                            {site.siteName}
                          </Option>
                        ))
                      ) : null
                    }
                    {
                      this.state.selectedRegionID.length === 0 && this.state.selectedDepotID.length !== 0 ? (
                        this.state.newSiteList
                          .filter((site) => this.state.selectedDepotID.includes(site.depotId))
                          .map((site) => (
                            <Option className="textStyles-small" key={site.id} value={site.id}>
                              {site.siteName}
                            </Option>
                          ))
                      ) : null
                    }
                    {
                      this.state.selectedRegionID.length !== 0 && this.state.selectedDepotID.length === 0 ? (
                        this.state.newSiteList
                          .filter((site) => this.state.selectedRegionID.includes(site.regionId))
                          .map((site) => (
                            <Option className="textStyles-small" key={site.id} value={site.id}>
                              {site.siteName}
                            </Option>
                          ))
                      ) : null
                    }
                    {
                      this.state.selectedRegionID.length !== 0 && this.state.selectedDepotID.length !== 0 ? (
                        this.state.newSiteList
                          .filter((site) => this.state.selectedDepotID.includes(site.depotId))
                          .map((site) => (
                            <Option className="textStyles-small" key={site.id} value={site.id}>
                              {site.siteName}
                            </Option>
                          ))
                      ) : null
                    }
                  </Select>
                </Form.Item>
              </Panel>
              <Divider />
              <Panel header={<span className="textStyles-small" style={{ fontSize: 12 }}>Status</span>} key="4">
                <Form.Item name="status">
                  <Select placeholder="Select Status" bordered={false} defaultValue={null}
                    style={{ width: "100%", height: 'auto' }}
                    className='borderedSelect'>
                    <Option className="textStyles-small" value={null}><Badge color="blue" style={{ marginRight: 10 }} />All</Option>
                    <Option className="textStyles-small" value="Live"><Badge color="green" style={{ marginRight: 10 }} />Live</Option>
                    <Option className="textStyles-small" value="Removed"><Badge color="red" style={{ marginRight: 10 }} />Removed</Option>
                  </Select>
                </Form.Item>
              </Panel>
              <Divider />
              <Panel header={<span className="textStyles-small" style={{ fontSize: 12 }}>Site Owner</span>} key="5">
                <Form.Item name="siteOwner">
                  <Select
                    placeholder="Select Site Owner"
                    bordered={false}
                    style={{ width: "100%", height: 'auto' }}
                    mode='multiple'
                    className='borderedSelect'
                    showSearch
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {this.state.siteOwnerList.map((siteOwner) => (
                      <Option className="textStyles-small" key={siteOwner.id} value={siteOwner.id}>
                        {siteOwner.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Panel>
              <Divider />
              <Panel header={<span className="textStyles-small" style={{ fontSize: 12 }}>Site Type</span>} key="6">
                <Form.Item name="siteType">
                  <Select
                    placeholder="Select Site Type"
                    bordered={false}
                    style={{ width: "100%", height: 'auto' }}
                    showSearch
                    mode='multiple'
                    className='borderedSelect'
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {this.state.siteTypeList.map((siteType) => (
                      <Option className="textStyles-small" key={siteType.id} value={siteType.id}>
                        {siteType.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Panel>
              <Divider />
              <Panel header={<span className="textStyles-small" style={{ fontSize: 12 }}>Tower Category</span>} key="7">
                <Form.Item name="towerCategory">
                  <Select
                    placeholder="Select Tower Category"
                    bordered={false}
                    style={{ width: "100%", height: 'auto' }}
                    showSearch
                    mode='multiple'
                    className='borderedSelect'
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {this.state.towerCategoryList.map((towerCategory) => (
                      <Option className="textStyles-small" key={towerCategory.id} value={towerCategory.id}>
                        {towerCategory.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Panel>
              <Divider />
              <Panel header={<span className="textStyles-small" style={{ fontSize: 12 }}>Tower Type</span>} key="8">
                <Form.Item name="towerType">
                  <Select
                    placeholder="Select Tower Type"
                    bordered={false}
                    style={{ width: "100%", height: 'auto' }}
                    showSearch
                    mode='multiple'
                    className='borderedSelect'
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {this.state.towerTypeList.map((towerType) => (
                      <Option className="textStyles-small" key={towerType.id} value={towerType.id}>
                        {towerType.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Panel>
              <Button
                type="button"
                class="btn btn-soft-primary btn-sm"
                htmlType="submit"
                style={{ borderColor: '#BA183A', backgroundColor: '#BA183A', borderRadius: '5px', width: '100%', height: '34px', marginTop: 10 }}
              >
                <span className="textStyles-small" style={{ color: 'white', fontSize: 13 }}>Filter</span>
              </Button>
            </Collapse>
          </Form>
        </Fragment>
      },
      {
        key: '2',
        label: <span className='textStyles-small' style={{ fontSize: 12 }}>Templates</span>,
        children: <Fragment>
          <Input
            placeholder="Search templates..."
            onChange={(e) => this.filterTemplatesByName(e.target.value)}
            style={{ marginBottom: 20, width: '100%', height: 34 }}
            className="borderedSelect"
          />
          <div style={{ overflowY: 'auto', height: '60vh' }} className='custom-scroll'>
            {
              this.state.searchSavedTemplates.map((template, index) => (
                <div key={index} style={{ padding: 10, border: '#f4f4f4', borderRadius: 12, cursor: 'pointer', width: '100%', marginTop: 5, backgroundColor: '#f4f4f4' }}>
                  <Row span={24}>
                    <Col span={20}>
                      <span className="textStyles-small">{template?.templateName.replace(/_/g, ' ')}</span>
                    </Col>
                    <Col span={4}>
                      <Button
                        onClick={() => {
                          this.setState({
                            isActiveFilter: true,
                            allSiteList: [],
                            pagination: {
                              current: 1,
                              pageSize: 10,
                              total: 0,
                              totalPages: 0,
                              lastSeenId: 0,
                              hasNextPage: true
                            }
                          });
                          this.filterBtnClick(JSON.parse(template?.parameters), 0, true);
                        }}
                        shape="circle"
                        style={{
                          marginLeft: 10,
                          backgroundColor: '#BA183A',
                          borderColor: '#BA183A',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer'
                        }}
                      >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M16 8.00023L18.3642 5.63609M5.63631 18.364L8.00026 16M17.6566 12H21M3 12H6.34315M12 6.34342L12 3M12 21L12 17.6569M8.00023 8.00023L5.63609 5.63609M18.364 18.364L16 16" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </Button>
                    </Col>
                  </Row>
                </div>
              ))
            }
          </div>
        </Fragment>
      }
    ]

    return (
      <>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="page-title-box">
                <div className="row">
                  <div class="col">
                    <h4 class="page-title"><span className='textStyles-small' style={{ fontSize: 15, fontWeight: 'bold' }}>Site List</span></h4>
                    <ol class="breadcrumb">
                      <li class="breadcrumb-item">
                        <a href="javascript:void(0);"><span className='textStyles-small' style={{ fontSize: 12 }}>Site View</span></a>
                      </li>
                      <li class="breadcrumb-item">
                        <a href="javascript:void(0);"><span className='textStyles-small' style={{ fontSize: 12 }}>Site List</span></a>
                      </li>
                    </ol>
                  </div>
                  <div className="col align-right">
                    {checkPermissions('SITE_VIEW_GENERAL_USER') || checkPermissions('SITE_VIEW_ADMIN_USER') ? (
                      <Link to="/site/create/new">
                        <Button
                          style={{ marginLeft: 10, backgroundColor: '#BA183A', borderColor: '#BA183A', borderRadius: 12, height: 39, width: 122 }}
                        >
                          <svg width="16" height="22" viewBox="0 0 19 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.8576 9.3075L16.1629 8.84491C16.9754 7.67433 17.4484 6.3104 17.5317 4.89804C17.615 3.48568 17.3054 2.07763 16.636 0.823478L16.4955 0.571385L17.228 0.166687L17.3807 0.441309C18.121 1.82745 18.4633 3.38385 18.3712 4.94502C18.2791 6.50619 17.756 8.01378 16.8576 9.3075ZM6.20061 21.035H4.48062L7.08525 9.25224C7.12581 9.06853 7.22951 8.90394 7.37909 8.7859C7.52867 8.66786 7.7151 8.60349 7.90732 8.60351H9.12748V6.29454C8.70799 6.19949 8.33343 5.96913 8.06416 5.64057C7.79489 5.31201 7.64657 4.90438 7.64311 4.48335C7.64311 4.23354 7.69343 3.98617 7.7912 3.75538C7.88897 3.52458 8.03228 3.31487 8.21294 3.13823C8.3936 2.96158 8.60807 2.82146 8.84411 2.72586C9.08015 2.63026 9.33314 2.58106 9.58863 2.58106C9.84412 2.58106 10.0971 2.63026 10.3332 2.72586C10.5692 2.82146 10.7837 2.96158 10.9643 3.13823C11.145 3.31487 11.2883 3.52458 11.3861 3.75538C11.4838 3.98617 11.5342 4.23354 11.5342 4.48335C11.5305 4.91824 11.3722 5.33834 11.0866 5.6717C10.8009 6.00506 10.4056 6.23094 9.96839 6.31066V8.60417H11.1832C11.3753 8.60415 11.5616 8.66844 11.7111 8.78635C11.8606 8.90426 11.9644 9.06867 12.0051 9.25224L14.6082 21.0344L6.20061 21.035ZM11.1391 13.1183H7.95122L7.40832 15.5736H11.6818L11.1391 13.1183ZM7.22652 16.3959L6.68279 18.8546H12.407L11.8636 16.3959H7.22652ZM8.5856 10.2486L8.13302 12.2961H10.9575L10.5047 10.2486H8.5856ZM6.20061 21.035H12.889L12.5887 19.6769H6.50048L6.20061 21.035ZM5.68278 6.97255C5.18044 6.22674 4.91497 5.35229 4.91979 4.45929C4.9246 3.56628 5.19949 2.69462 5.70986 1.95403L5.01341 1.49474C4.40975 2.36973 4.08458 3.3999 4.07889 4.45535C4.07321 5.5108 4.38726 6.54427 4.98146 7.42543L5.68278 6.97255ZM15.0115 4.48335C15.0125 3.43945 14.7002 2.41821 14.1132 1.54621L13.4102 1.99909C13.9113 2.74458 14.1758 3.61823 14.1705 4.51026C14.1652 5.40229 13.8904 6.27289 13.3806 7.01267L14.0771 7.47197C14.6876 6.58974 15.0131 5.54858 15.0115 4.48335ZM2.86439 8.78884C2.04994 7.57854 1.59472 6.1711 1.54932 4.72299C1.50393 3.27488 1.87013 1.84282 2.60724 0.58602L1.87817 0.174909C1.06328 1.5641 0.658469 3.14709 0.708767 4.7478C0.759064 6.34852 1.2625 7.90422 2.16307 9.24188L2.86439 8.78884Z" fill="white" />
                            <circle cx="14.1702" cy="20.2083" r="4.625" fill="white" />
                            <path d="M15.9045 19.6302H14.7483V18.4739C14.7483 18.3206 14.6874 18.1736 14.579 18.0651C14.4705 17.9567 14.3235 17.8958 14.1702 17.8958C14.0168 17.8958 13.8698 17.9567 13.7614 18.0651C13.653 18.1736 13.592 18.3206 13.592 18.4739V19.6302H12.4358C12.2825 19.6302 12.1354 19.6911 12.027 19.7995C11.9186 19.9079 11.8577 20.055 11.8577 20.2083C11.8577 20.3616 11.9186 20.5087 12.027 20.6171C12.1354 20.7255 12.2825 20.7864 12.4358 20.7864H13.592V21.9427C13.592 22.096 13.653 22.2431 13.7614 22.3515C13.8698 22.4599 14.0168 22.5208 14.1702 22.5208C14.3235 22.5208 14.4705 22.4599 14.579 22.3515C14.6874 22.2431 14.7483 22.096 14.7483 21.9427V20.7864H15.9045C16.0579 20.7864 16.2049 20.7255 16.3133 20.6171C16.4218 20.5087 16.4827 20.3616 16.4827 20.2083C16.4827 20.055 16.4218 19.9079 16.3133 19.7995C16.2049 19.6911 16.0579 19.6302 15.9045 19.6302Z" fill="#BA183A" />
                          </svg>

                          <span className='textStyles-small' style={{ color: 'white', marginLeft: 10 }}>Create Site</span>
                        </Button>
                      </Link>
                    ) : null}
                    <Button
                      style={{ marginLeft: 10, backgroundColor: '#BA183A', borderColor: '#BA183A', borderRadius: 12, height: 39, width: 112 }}
                      onClick={() => {
                        localStorage.setItem('mapQuery', JSON.stringify(this.state.mapQuery));
                        window.location.href = '/site/map/new';
                      }}
                    >
                      <svg width="18" height="18" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21.75 5.43344C21.75 4.23043 21.75 3.62892 21.4236 3.17608C21.0972 2.72323 20.5266 2.53301 19.3853 2.15258L18.0426 1.70502C16.4666 1.17969 15.6787 0.917035 14.8853 1.02327C14.092 1.12951 13.4009 1.59025 12.0186 2.51172L10.4251 3.57411C9.346 4.29347 8.80651 4.65315 8.20123 4.79622C7.97893 4.84878 7.75198 4.87917 7.52368 4.88696C6.90209 4.90819 6.28694 4.70314 5.05664 4.29304C3.44515 3.75588 2.6394 3.48729 2.02631 3.76004C1.80864 3.85687 1.61332 3.99765 1.45263 4.17353C1 4.6689 1 5.51823 1 7.2169V11.902M21.75 9.85747V14.8037C21.75 16.5023 21.75 17.3517 21.2974 17.847C21.1367 18.0229 20.9413 18.1637 20.7237 18.2605C20.1106 18.5333 19.3048 18.2647 17.6934 17.7275C16.463 17.3174 15.8479 17.1124 15.2263 17.1336C14.9981 17.1414 14.7711 17.1717 14.5488 17.2243C13.9435 17.3674 13.404 17.727 12.3249 18.4465L10.7314 19.5088C9.34911 20.4303 8.65803 20.8911 7.86471 20.9972C7.07138 21.1035 6.2834 20.8408 4.70744 20.3155L3.36472 19.868C2.22343 19.4875 1.65278 19.2973 1.3264 18.8444C1.01737 18.4157 1.00092 17.8537 1.00005 16.7741"
                          stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" />
                        <path d="M14.8333 1.21167V5.24639M14.8333 16.7742V9.8575" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" />
                        <path d="M7.91675 20.8088V16.7741M7.91675 5.24634V12.163" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" />
                      </svg>
                      <span className='textStyles-small' style={{ color: 'white', marginLeft: 10 }}>Map</span>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Modal
            title={<span className="textStyles-small" style={{ fontSize: 15 }}>Filter By</span>}
            open={this.state.openFilter}
            onCancel={() => this.setState({ openFilter: false })}
            onOk={() => this.setState({ openFilter: false })}
            destroyOnClose={false}
            width={350}
            footer={null}
            header={null}
            style={{
              position: 'fixed',
              top: 20,
              right: 20,
              overflow: 'auto',
            }}
          >
            <Tabs defaultActiveKey="1" items={tabItems}
              tabBarStyle={{ width: '100%' }}
              className="custom-tabs" />
          </Modal>

          <Row>
            <Col span={8}>
              <div style={{ backgroundColor: 'white', borderRadius: '15px', margin: 10, padding: 20 }}>
                <Row>
                  <Col span={12}>
                    <span className="textStyles-small" style={{ fontSize: 12, color: 'gray', fontWeight: 'bold' }}>
                      Region Count
                    </span> <br />
                    <span className="textStyles-small" style={{ fontSize: 20, color: 'black', fontWeight: 'bold' }}>
                      {
                        this.state.staticalData.regionCount
                      }
                    </span>
                  </Col>
                  <Col
                    span={12}
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      alignItems: 'center'
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: '#BA183A',
                        borderColor: '#BA183A',
                        borderRadius: 12,
                        padding: 10,
                        width: '40px',
                        height: '40px',
                      }}
                    >
                      <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8239 25.5345C19.4822 24.5195 20.142 23.2145 20.6161 21.5397C21.7109 21.9603 22.462 22.462 22.923 22.8578C21.7418 24.0311 20.3269 24.9426 18.7703 25.5331H18.8239V25.5345ZM6.0639 22.8447C6.5511 22.4489 7.28915 21.9602 8.3839 21.5252C8.8711 23.213 9.50475 24.518 10.1761 25.5331C8.64248 24.9298 7.25101 24.0143 6.09 22.8447H6.0639ZM21.4861 13.1819C21.4455 12.0075 21.3266 10.8344 21.1308 9.67585C22.5809 9.14805 23.635 8.51585 24.3731 7.93585C25.4022 9.51126 26.0396 11.31 26.232 13.1819H21.4861ZM8.47525 7.09195C7.70797 6.80925 6.98488 6.41866 6.3278 5.93195C7.4391 4.86917 8.74601 4.03204 10.1761 3.46695C9.55695 4.38915 8.95085 5.57525 8.4622 7.09195H8.4767H8.47525ZM18.8239 3.46695C20.2549 4.03022 21.5622 4.86756 22.6722 5.93195C22.0143 6.41744 21.2914 6.80794 20.5248 7.09195C20.1318 5.80709 19.5545 4.58604 18.8109 3.46695H18.8239ZM18.56 10.3211C18.6905 11.1911 18.8239 12.1278 18.85 13.1819H10.15C10.1892 12.1278 10.2805 11.1781 10.4139 10.3211C13.1037 10.8054 15.8572 10.8054 18.547 10.3211H18.56ZM14.5 8.04025C13.1805 8.04025 12.0205 7.93585 11.0345 7.7778C12.0872 4.53415 13.7228 3.22915 14.5 2.76805C15.2511 3.22915 16.8997 4.5472 17.9539 7.7778C16.8114 7.95672 15.6564 8.04448 14.5 8.04025ZM4.6139 7.93585C5.59956 8.68525 6.69845 9.27262 7.86915 9.67585C7.67346 10.8354 7.55478 12.0067 7.5139 13.1819H2.7144C2.92259 11.3053 3.5785 9.50615 4.62695 7.93585H4.6139ZM2.7289 15.8181H7.5139C7.5661 16.952 7.6444 17.9931 7.8039 18.9428C6.58943 19.3599 5.45624 19.9839 4.4544 20.7872C3.50629 19.2836 2.91138 17.5847 2.7144 15.8181H2.7289ZM14.5 17.9278C12.9195 17.9278 11.5609 18.0583 10.3748 18.27C10.2589 17.4574 10.1839 16.6396 10.15 15.8195H18.85C18.8109 16.7011 18.7442 17.5305 18.6397 18.27C17.2739 18.0231 15.888 17.9041 14.5 17.9147V17.9278ZM14.5 26.232C13.7098 25.7578 11.9698 24.347 10.9142 20.8278C12.0994 20.6347 13.2993 20.5464 14.5 20.5639C15.8848 20.5639 17.0709 20.6553 18.0989 20.8278C17.0448 24.3861 15.3048 25.7578 14.5131 26.232H14.5ZM24.5442 20.7742C23.5435 19.9699 22.4106 19.3457 21.1961 18.9298C21.355 17.8993 21.4519 16.8602 21.4861 15.8181H26.2856C26.0867 17.5801 25.4904 19.2744 24.5442 20.7742ZM14.5 0C6.49165 0 0 6.49165 0 14.5C0 22.5084 6.49165 29 14.5 29C22.5084 29 29 22.5084 29 14.5C29 6.49165 22.5084 0 14.5 0Z" fill="white" />
                      </svg>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>

            <Col span={8}>
              <div style={{ backgroundColor: 'white', borderRadius: '15px', margin: 10, padding: 20 }}>
                <Row>
                  <Col span={12}>
                    <span className="textStyles-small" style={{ fontSize: 12, color: 'gray', fontWeight: 'bold' }}>
                      Depot Count
                    </span> <br />
                    <span className="textStyles-small" style={{ fontSize: 20, color: 'black', fontWeight: 'bold' }}>
                      {
                        this.state.staticalData.depotCount
                      }
                    </span>
                  </Col>
                  <Col
                    span={12}
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      alignItems: 'center'
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: '#BA183A',
                        borderColor: '#BA183A',
                        borderRadius: 12,
                        padding: 10,
                        width: '40px',
                        height: '40px',
                      }}
                    >
                      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21.4891 6.553L11.6097 0.179473C11.2388 -0.0598244 10.7612 -0.0598244 10.3904 0.179473L0.510905 6.553C-0.00828934 6.88798 -0.156182 7.57802 0.180536 8.09435C0.517403 8.61084 1.2113 8.75772 1.7302 8.42295L2.34971 8.02333V20.8823C2.34971 21.4977 2.85135 21.9967 3.47011 21.9967V22H13.6981C14.0314 22 14.3015 21.7313 14.3015 21.3998V17.766C14.3015 17.4345 14.0314 17.1658 13.6981 17.1658H10.4855V13.0384C10.4855 12.7069 10.2153 12.4382 9.88201 12.4382H7.4131V8.31248C7.4131 7.98098 7.14293 7.71226 6.80965 7.71226H4.59051V6.57766L11 2.44274L17.4095 6.57766V20.8823C17.4095 21.4977 17.9111 21.9967 18.5299 21.9967C19.1486 21.9967 19.6503 21.4977 19.6503 20.8823V8.02326L20.2698 8.42288C20.4581 8.54442 20.6695 8.60244 20.8784 8.60244C21.2453 8.60237 21.6048 8.42332 21.8194 8.09428C22.1562 7.57794 22.0083 6.88791 21.4891 6.553Z" fill="white" />
                      </svg>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>

            <Col span={8}>
              <div style={{ backgroundColor: 'white', borderRadius: '15px', margin: 10, padding: 20 }}>
                <Row>
                  <Col span={12}>
                    <span className="textStyles-small" style={{ fontSize: 12, color: 'gray', fontWeight: 'bold' }}>
                      Site Count
                    </span> <br />
                    <span className="textStyles-small" style={{ fontSize: 20, color: 'black', fontWeight: 'bold' }}>
                      {
                        this.state.staticalData.siteCount
                      }
                    </span>
                  </Col>
                  <Col
                    span={12}
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      alignItems: 'center'
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: '#BA183A',
                        borderColor: '#BA183A',
                        borderRadius: 12,
                        padding: 10,
                        width: '40px',
                        height: '40px',
                      }}
                    >
                      <svg width="27" height="31" viewBox="0 0 27 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M23.9954 13.5787L22.9633 12.8915C24.1703 11.1526 24.873 9.12652 24.9967 7.02845C25.1205 4.93038 24.6607 2.83871 23.6661 0.975666L23.4575 0.60118L24.5455 0L24.7724 0.407953C25.8721 2.46707 26.3806 4.77911 26.2438 7.09823C26.107 9.41736 25.33 11.6569 23.9954 13.5787ZM8.16436 31H5.6093L9.4785 13.4966C9.53875 13.2237 9.6928 12.9792 9.91501 12.8039C10.1372 12.6285 10.4141 12.5329 10.6997 12.5329H12.5122V9.10296C11.8891 8.96176 11.3327 8.61955 10.9327 8.13148C10.5327 7.6434 10.3123 7.03786 10.3072 6.41243C10.3072 6.04133 10.382 5.67387 10.5272 5.33102C10.6724 4.98817 10.8853 4.67665 11.1537 4.41424C11.4221 4.15183 11.7407 3.94368 12.0913 3.80167C12.4419 3.65966 12.8178 3.58656 13.1973 3.58656C13.5768 3.58656 13.9526 3.65966 14.3033 3.80167C14.6539 3.94368 14.9725 4.15183 15.2409 4.41424C15.5093 4.67665 15.7221 4.98817 15.8674 5.33102C16.0126 5.67387 16.0874 6.04133 16.0874 6.41243C16.0819 7.05845 15.8468 7.68251 15.4225 8.17772C14.9982 8.67293 14.411 9.00848 13.7614 9.1269V12.5339H15.566C15.8513 12.5339 16.1281 12.6294 16.3502 12.8046C16.5724 12.9797 16.7265 13.2239 16.7869 13.4966L20.6539 30.999L8.16436 31ZM15.5005 19.2397H10.7649L9.95843 22.8871H16.3067L15.5005 19.2397ZM9.68836 24.1085L8.88064 27.761H17.384L16.5768 24.1085H9.68836ZM11.7073 14.9767L11.035 18.0183H15.2307L14.5581 14.9767H11.7073ZM8.16436 31H18.1L17.6538 28.9825H8.60982L8.16436 31ZM7.39512 10.1101C6.64889 9.00224 6.25454 7.70324 6.26169 6.37668C6.26885 5.05011 6.6772 3.75525 7.43535 2.65511L6.40078 1.97283C5.50404 3.27264 5.02099 4.80296 5.01254 6.37083C5.0041 7.93871 5.47063 9.47392 6.35331 10.7829L7.39512 10.1101ZM21.253 6.41243C21.2545 4.8617 20.7905 3.34464 19.9186 2.04929L18.8743 2.72205C19.6186 3.82947 20.0115 5.12728 20.0037 6.45239C19.9958 7.77751 19.5876 9.0708 18.8303 10.1697L19.8649 10.852C20.7719 9.54148 21.2554 7.99482 21.253 6.41243ZM3.20839 12.8082C1.99853 11.0103 1.32229 8.91959 1.25486 6.76841C1.18742 4.61723 1.73142 2.48991 2.82639 0.622922L1.74336 0.0122141C0.532833 2.07587 -0.0685124 4.4274 0.0062045 6.80527C0.0809214 9.18315 0.828772 11.4941 2.16658 13.4812L3.20839 12.8082Z" fill="white" />
                      </svg>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>

          <div style={{ marginTop: 10, backgroundColor: "white", padding: 15, borderRadius: 15 }}>
            <div className="row">
              <Row>
                <Col span={12}>
                  <Row>
                    <span className="textStyles-small" style={{ fontSize: 18, fontWeight: 'bolder' }}>
                      Site List
                    </span>
                  </Row>
                </Col>
                <Col span={12}>
                  <Row align="middle" justify="end">
                    {
                      !this.state.loading && (
                        <Fragment>
                          <Select
                            bordered={false}
                            className='borderedSelect'
                            style={{ width: '250px' }}
                            placeholder="Search By Site Name or ID"
                            allowClear
                            showSearch
                            filterOption={(input, option) => {
                              const [siteName, siteId] = option.children.split(" - ");
                              return (
                                siteName.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                                siteId.toLowerCase().indexOf(input.toLowerCase()) >= 0
                              );
                            }}
                            defaultValue={this.state.inlineSearchID}
                            onChange={(value) => {
                              this.setState({
                                inlineSearchID: value,
                                isActiveFilter: false,
                                allSiteList: [],
                                pagination: {
                                  current: 1,
                                  pageSize: 10,
                                  total: 0,
                                  totalPages: 0,
                                  lastSeenId: null,
                                  hasNextPage: true
                                }
                              });
                              this.searchBar({ value })
                            }}
                          >
                            {
                              this.state.loadFullSiteList?.map((item, index) => (
                                <Select.Option key={index} value={item?.id} className='textStyles-small'>
                                  {`${item?.siteName} - ${item?.siteId}`}
                                </Select.Option>
                              ))
                            }
                          </Select>
                          <Button
                            type="button"
                            className="btn btn-soft-primary btn-sm"
                            style={{ borderColor: '#BA183A', backgroundColor: '#BA183A', borderRadius: '10px', width: '100px', height: '34px', marginLeft: 5 }}
                            onClick={() => this.setState({ openFilter: true })}
                          >
                            <svg width="15" height="15" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M10.25 2.66667C10.25 1.74619 9.46652 1 8.5 1C7.53348 1 6.75 1.74619 6.75 2.66667M10.25 2.66667C10.25 3.58714 9.46652 4.33333 8.5 4.33333C7.53348 4.33333 6.75 3.58714 6.75 2.66667M10.25 2.66667H15.5M6.75 2.66667H1.5M12 8.5C12 9.4205 12.7835 10.1667 13.75 10.1667C14.7165 10.1667 15.5 9.4205 15.5 8.5C15.5 7.5795 14.7165 6.83333 13.75 6.83333C12.7835 6.83333 12 7.5795 12 8.5ZM12 8.5H1.5M5 14.3333C5 13.4128 4.2165 12.6667 3.25 12.6667C2.2835 12.6667 1.5 13.4128 1.5 14.3333C1.5 15.2538 2.2835 16 3.25 16C4.2165 16 5 15.2538 5 14.3333ZM5 14.3333H15.5"
                                stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" />
                            </svg>
                            <span className="textStyles-small" style={{ color: 'white', fontSize: 13, marginLeft: 10 }}>Filter</span>
                          </Button>
                        </Fragment>
                      )
                    }
                  </Row>
                </Col>
              </Row>

              <Table
                size="small"
                className="table-striped-rows"
                style={{ marginTop: 10 }}
                columns={columns123}
                loading={this.state.loading}
                dataSource={this.state.allSiteList}
                pagination={{
                  current: this.state.pagination.current,
                  pageSize: this.state.pagination.pageSize,
                  total: this.state.pagination.total,
                  showSizeChanger: false,
                }}
                onChange={this.handleTableChange}
              />

            </div>
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    organization_count: state.organization.length,
    regions: state.regions,
    depots: state.depots,
    sites_count: state.sites.length,
    vendor_count: state.vendor.length,
    roles_count: state.roles.length,
  };
}

export default connect(mapStateToProps, { getDonationCategories, getData })(
  SiteAll
);
